module.exports = __webpack_public_path__ + "img/businessImg1.bf92f88d.png";